import './styles/DataGrid.scss';

import {
  DataGrid as MuiDataGrid,
  DataGridProps,
  GridCsvExportOptions,
  GridPrintExportOptions,
  GridToolbarContainer,
  GridToolbarExport
} from '@mui/x-data-grid';

import { FilterProps, Filters } from '../Filters';

interface ToolBarProps {
  filters?: FilterProps;
  exportEnabled?: boolean;
  csvOptions?: GridCsvExportOptions;
  printOptions?: GridPrintExportOptions;
}

export type CommunityDataGrid = DataGridProps & {
  slotProps?: { toolbar?: ToolBarProps };
};

export const DataGrid: React.FC<CommunityDataGrid> = props => {
  return (
    <div className="community-data-grid">
      <MuiDataGrid
        disableColumnFilter
        {...props}
        slots={{
          ...props.slots,
          toolbar: CustomToolbar
        }}
      />
    </div>
  );
};

const CustomToolbar = (componentProps: ToolBarProps) => {
  return (
    <>
      {!!Object.keys(componentProps).length && (
        <GridToolbarContainer
          style={{
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'wrap',
            alignItems: 'center',
            justifyContent: 'space-between'
          }}
        >
          {componentProps.filters && <Filters {...componentProps.filters} />}
          {componentProps.exportEnabled && (
            <GridToolbarExport
              csvOptions={componentProps.csvOptions}
              printOptions={componentProps.printOptions}
            />
          )}
        </GridToolbarContainer>
      )}
    </>
  );
};
